import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface PillButtonProps {
  readonly children: ReactNode;
  readonly active?: boolean;
  readonly onClick?: () => void;
}

export function PillButton({ children, active, onClick }: PillButtonProps): JSX.Element {
  return (
    <button
      className={cn(
        "border rounded-full px-3 py-[5px] text-xs font-medium leading-none cursor-pointer transition-all duration-[180ms] ease-out",
        active
          ? "bg-accent border-transparent text-white"
          : "border-edge bg-surface-hover text-content hover:border-edge-strong",
      )}
      type="button"
      onClick={onClick}
    >
      {children}
    </button>
  );
}
